import BaseServiceApi from 'BaseServiceApi'
import SaveUserEventFavouriteRequest from "../Requests/SaveUserEventFavouriteRequest";

class ListManagerCalendarApi {
  saveUserEventFavourite(data) {
    const req = new SaveUserEventFavouriteRequest(data);
    return BaseServiceApi.processServiceCall(req);
  }
}
const listManagerCalendarApi = new ListManagerCalendarApi();
export default listManagerCalendarApi;